// extracted by mini-css-extract-plugin
export default {"cls1":"ImpactHubModal-cls1__ac039175f85913d89299","cls2":"ImpactHubModal-cls2___dc0415ab035a4f06f1c ImpactHubModal-cls1__ac039175f85913d89299"};